import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const SellerListingPrice = () => {
  const { seller_id } = useParams();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch listings from API
  const fetchListings = async () => {
    if (!seller_id) {
      console.error("Seller ID is missing.");
      return;
    }
    try {
      const response = await axios.get(`${baseurl}/fetchSellerListingById/${seller_id}`);
      if (response.data && response.data.data) {
        // ✅ Only keep approved listings
        const approvedListings = response.data.data.filter(
          (listing) => listing.status === "approved"
        );
        setListings(approvedListings);
      }
    } catch (error) {
      console.error("Error fetching listings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchListings();
  }, [seller_id]);

  // Calculate total (sum of price × quantity) only for approved
  const totalAmount = listings.reduce((acc, item) => {
    const price = parseFloat(item.price) || 0;
    const qty = parseInt(item.quantity) || 0;
    return acc + price * qty;
  }, 0);

  // ✅ Download Excel
  const downloadExcel = () => {
    const tableData = listings.map((item, index) => ({
      "#": index + 1,
      By: item.business_name,
      Title: item.title,
      Condition: item.condition,
      Price: `${item.price} ${item.currency}`,
      Quantity: item.quantity,
      Total: (parseFloat(item.price || 0) * (parseInt(item.quantity) || 0)).toFixed(2) + " " + item.currency,
    }));

    // Add Grand Total row
    tableData.push({
      "#": "",
      Title: "",
      Condition: "",
      Price: "",
      Quantity: "Grand Total",
      Total: totalAmount.toFixed(2),
    });

    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Seller Listings");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `seller_${seller_id}_listings.xlsx`);
  };

  return (
    <div className="container-fluid mt-4">
      <h4 className="mb-3">Seller Listings (Approved Only)</h4>

      {/* ✅ Grand Total Highlighted */}
      <div className="alert alert-success d-flex justify-content-between align-items-center">
        <strong>Grand Total: {Number(totalAmount || 0).toLocaleString("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})}</strong>
        <button onClick={downloadExcel} className="btn btn-primary btn-sm">
          Download Excel
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : listings.length === 0 ? (
        <p>No approved listings found.</p>
      ) : (
        <div className="card">
          <div className="card-body table-responsive">
            <table className="custom-table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>By</th>
                  <th>Title</th>
                  <th>Condition</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {listings.map((listing, index) => {
                  const price = parseFloat(listing.price) || 0;
                  const qty = parseInt(listing.quantity) || 0;
                  const rowTotal = price * qty;

                  return (
                    <tr key={listing.listing_unique_id}>
                      <td>{index + 1}</td>
                      <td>{listing.business_name}</td>
                      <td>{listing.title}</td>
                      <td>{listing.condition}</td>
                      <td>
                        {listing.price} {listing.currency}
                      </td>
                      <td>{listing.quantity}</td>
                      <td>
                        {rowTotal.toFixed(2)} {listing.currency}
                      </td>
                    </tr>
                  );
                })}

                {/* Grand Total row inside table */}
                <tr className="fw-bold">
                  <td colSpan="5" className="text-end">
                    Grand Total
                  </td>
                  <td>
                    {Number(totalAmount || 0).toLocaleString("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})}
{/* {totalAmount.toFixed(2)} */}
</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default SellerListingPrice;
